import { render, staticRenderFns } from "./CourseConfigPartner.vue?vue&type=template&id=5152c47e&scoped=true"
import script from "./CourseConfigPartner.vue?vue&type=script&lang=js"
export * from "./CourseConfigPartner.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CourseConfigPartner.vue?vue&type=style&index=1&id=5152c47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152c47e",
  null
  
)

export default component.exports